export default __webpack_public_path__ + "img/airflow-icon16.eb785186f639f2cc28610b4e0286ab2b.png";